// Small display helpers shared by the Active Taxpayer List screens.

export const formatCount = (value) => (Number(value) || 0).toLocaleString("en-US");

export const formatBytes = (bytes) => {
  const value = Number(bytes) || 0;
  if (value >= 1024 * 1024 * 1024) return `${(value / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  if (value >= 1024 * 1024) return `${(value / (1024 * 1024)).toFixed(1)} MB`;
  if (value >= 1024) return `${Math.round(value / 1024)} KB`;
  return `${value} B`;
};

export const formatDuration = (ms) => {
  const seconds = Math.round((Number(ms) || 0) / 1000);
  if (seconds < 1) return "under 1 sec";
  if (seconds < 60) return `${seconds} sec`;
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return rest ? `${minutes} min ${rest} sec` : `${minutes} min`;
};

export const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "-";
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

// What the server calls each step of an import, in words for the admin.
export const PHASE_LABELS = {
  reading: "Reading the Excel file",
  building: "Building the search database",
  verifying: "Checking the new list",
  publishing: "Switching to the new list",
};

export const STATUS_STYLES = {
  completed: { label: "Completed", className: "bg-green-100 text-green-700" },
  failed: { label: "Failed", className: "bg-red-100 text-red-700" },
  cancelled: { label: "Cancelled", className: "bg-slate-100 text-slate-600" },
  processing: { label: "Processing", className: "bg-blue-100 text-blue-700" },
  uploading: { label: "Uploading", className: "bg-amber-100 text-amber-700" },
};
